export const FIND_ASSIGNABLE_ROUTINES = `
  query FindAssignableRoutines($filter: FindAssignableRoutinesFilter!, $page: PageRequest) {
    group {
      findAssignableRoutines(filter: $filter, page: $page) {
        count
        limit
        offset
        items {
          id
          name
          type
          config
          order
          deactivated
          groups {
            id
            name
          }
          inAssignments
        }
      }
    }
  }
`;
